import { render, staticRenderFns } from "./CodeItem.vue?vue&type=template&id=fe3d788e&scoped=true"
import script from "./CodeItem.vue?vue&type=script&lang=js"
export * from "./CodeItem.vue?vue&type=script&lang=js"
import style0 from "./CodeItem.vue?vue&type=style&index=0&id=fe3d788e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3d788e",
  null
  
)

export default component.exports